import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "QuoteSorted — Quoting, Invoicing & Certificates for UK Tradespeople",
  description = "The all-in-one app for electricians and plumbers. Professional quotes in 15 seconds, invoices, EIC/EICR certificates, customer management and more.",
  path = "/",
  type = "website"
}) => {
  const baseUrl = "https://quotesorted.uk";
  const fullUrl = `${baseUrl}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEOHead;
